import { render } from "./OffersEcommerce.vue.ts?vue&type=template&id=772c3488&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OffersEcommerce.vue?vue&type=template&id=772c3488&scoped=true&ts=true"
import script from "./OffersEcommerce.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OffersEcommerce.vue?vue&type=script&setup=true&lang=ts"
export * from "./OffersEcommerce.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OffersEcommerce.vue?vue&type=script&setup=true&lang=ts"

import "./OffersEcommerce.vue.scss?vue&type=style&index=0&id=772c3488&scoped=true&lang=scss!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OffersEcommerce.vue?vue&type=style&index=0&id=772c3488&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772c3488"],['__file',"src/apps/merchant3/components/offers/OffersEcommerce.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "772c3488"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('772c3488', __exports__)) {
    api.reload('772c3488', __exports__)
  }
  
  module.hot.accept("./OffersEcommerce.vue.ts?vue&type=template&id=772c3488&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./OffersEcommerce.vue?vue&type=template&id=772c3488&scoped=true&ts=true", () => {
    api.rerender('772c3488', render)
  })

}


export default __exports__